var _filter, _filter2, _filter3, _filter4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1651_6342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "translate(0.144287)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8443 49.8L52.6443 30L67.0443 15.6H67.9443L76.0443 23.7V41.4L91.0443 56.4L42.7443 104.7L28.9443 90.9L51.4443 68.4L32.8443 49.8Z",
    fill: "#D5D6D8",
    stroke: "#808389",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "#808389",
      stroke: "color(display-p3 0.5020 0.5137 0.5373)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1651_6342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1443 56.4L43.6443 105.9L42.7443 106.8L40.6443 104.7L22.6443 122.4L121.044 123.6V67.5L77.5443 24V40.8L93.1443 56.4Z",
    fill: "url(#paint0_linear_1651_6342)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1443 56.4L43.6443 105.9L42.7443 106.8L40.6443 104.7L22.6443 122.4L121.044 123.6V67.5L77.5443 24V40.8L93.1443 56.4Z",
    stroke: "#D5D6D8",
    style: {
      stroke: "#D5D6D8",
      stroke: "color(display-p3 0.8353 0.8392 0.8471)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1651_6342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5443 119.4L39.4443 103.5L26.8443 90.9L49.3443 68.4L-1.6557 17.4V122.7H23.5443V119.4Z",
    fill: "url(#paint1_linear_1651_6342)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5443 119.4L39.4443 103.5L26.8443 90.9L49.3443 68.4L-1.6557 17.4V122.7H23.5443V119.4Z",
    stroke: "#D5D6D8",
    style: {
      stroke: "#D5D6D8",
      stroke: "color(display-p3 0.8353 0.8392 0.8471)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1651_6342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7443 -1.20001L31.9443 48.6L-12.7557 3.89999V-1.20001H81.7443Z",
    fill: "url(#paint2_linear_1651_6342)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7443 -1.20001L31.9443 48.6L-12.7557 3.89999V-1.20001H81.7443Z",
    stroke: "#D5D6D8",
    style: {
      stroke: "#D5D6D8",
      stroke: "color(display-p3 0.8353 0.8392 0.8471)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1651_6342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.644 -2.09998L78.7443 22.8L121.044 65.1V-2.09998H103.644Z",
    fill: "url(#paint3_linear_1651_6342)",
    fillOpacity: 0.2,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.644 -2.09998L78.7443 22.8L121.044 65.1V-2.09998H103.644Z",
    stroke: "#D5D6D8",
    style: {
      stroke: "#D5D6D8",
      stroke: "color(display-p3 0.8353 0.8392 0.8471)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.144287,
    width: 120,
    height: 120,
    fill: "url(#paint4_radial_1651_6342)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1651_6342",
    x: 21.3203,
    y: 22.6758,
    width: 100.624,
    height: 101.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1651_6342"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1651_6342",
    x: -2.55569,
    y: 16.0758,
    width: 52.9242,
    height: 107.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1651_6342"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1651_6342",
    x: -13.6557,
    y: -2.1,
    width: 96.7242,
    height: 51.7242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1651_6342"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1651_6342",
    x: 77.72,
    y: -2.99996,
    width: 44.2242,
    height: 69.4242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1651_6342"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1651_6342",
    x1: 69.1443,
    y1: 80.7,
    x2: 119.844,
    y2: 119.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D6D8",
    style: {
      stopColor: "#D5D6D8",
      stopColor: "color(display-p3 0.8353 0.8392 0.8471)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1651_6342",
    x1: 44.8443,
    y1: 68.7,
    x2: -2.5557,
    y2: 72.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404846,
    stopColor: "#D5D6D8",
    style: {
      stopColor: "#D5D6D8",
      stopColor: "color(display-p3 0.8353 0.8392 0.8471)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1651_6342",
    x1: 46.3443,
    y1: 33,
    x2: 37.269,
    y2: -6.42829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D6D8",
    style: {
      stopColor: "#D5D6D8",
      stopColor: "color(display-p3 0.8353 0.8392 0.8471)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1651_6342",
    x1: 84.4443,
    y1: 29.1,
    x2: 103.754,
    y2: -8.68315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D6D8",
    style: {
      stopColor: "#D5D6D8",
      stopColor: "color(display-p3 0.8353 0.8392 0.8471)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1651_6342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.1443 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1651_6342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.144287)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholder);
export default __webpack_public_path__ + "static/media/location-placeholder.ef7fefb8572e5061f84d51ae89b92148.svg";
export { ForwardRef as ReactComponent };